import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    corporationId: string;
    userId: string;
};

export const schemaCorporationResolver_IsDirectorOfThisCorporation = z.boolean();

export type SchemaCorporationResolver_IsDirectorOfThisCorporation = z.infer<
    typeof schemaCorporationResolver_IsDirectorOfThisCorporation
>;

export type CorporationResolver_IsDirectorOfThisCorporation = Resolver<
    Arguments,
    SchemaCorporationResolver_IsDirectorOfThisCorporation
>;
